const SvgComponent = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 1a8 8 0 1 1 0 16A8 8 0 0 1 9 1Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx={9}
      cy={5.25}
      r={0.5}
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.5}
    />
    <rect
      x={8.625}
      y={7.875}
      width={0.75}
      height={5.25}
      rx={0.375}
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.75}
    />
  </svg>
)

export default SvgComponent